module.exports = {
    hints: "warning", // enum
    maxAssetSize: 200000, // int (in bytes),
    maxEntrypointSize: 400000, // int (in bytes)
    assetFilter: function(assetFilename) {
        // Function predicate that provides asset filenames
        if (assetFilename.endsWith('webpack-hot-middleware/client.js')) {
            return false
        }
        return assetFilename.endsWith('.css') || assetFilename.endsWith('.js');
    }
}


// WEBPACK FOOTER //
// ./src/technologies/perf.js